export function preloadImage(url) {
  const img = new Image();
  img.src = url;
}

export function preloadVideo(url) {
  const video = document.createElement("video");
  video.src = url;
  video.preload = "true";
  video.load();
  console.log("Preloading video:", url);
}

const importAllProjectImages = () => {
  const images = require.context(
    "../Images/Imagenes proyectos",
    true,
    /\.(png|jpe?g|svg|mp4)$/,
  );
  const allPaths = images.keys();

  const grouped = allPaths.reduce((acc, path) => {
    const cleanPath = path.replace("./", "");
    const parts = cleanPath.split("/");

    const folder = parts.length > 1 ? parts[0] : "root";
    const fileName = parts[parts.length - 1];

    if (!acc[folder]) acc[folder] = [];
    acc[folder].push({
      name: fileName,
      src: images(path),
    });

    return acc;
  }, {});

  return grouped;
};

export const getVideos = () => {
  const folder = require.context(
    "../Images/Imagenes proyectos",
    true,
    /\.(mp4)$/,
  );
  const allPaths = folder.keys();
  return allPaths.map((key) => key.replace("./", ""));
};

export const projectImages = importAllProjectImages();
